import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {RouterLink} from "@angular/router";
import {ApplicationConfig, config} from '../../../../config';
import {BadgeComponent} from "../../../shared-module/components/badge/badge.component";
import PhonePipe from "../../../shared-module/pipes/phone.pipe";
import {CardComponent} from "../../../shared-module/components/card/card.component";

@Component({
    selector: 'app-customer-support',
  imports: [
    ButtonComponent,
    RouterLink,
    BadgeComponent,
    PhonePipe,
    CardComponent,
  ],
    templateUrl: './customer-support.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './customer-support.component.scss'
})
export class CustomerSupportComponent {
  public config: ApplicationConfig = config;

}
